<!-- Dialog: CSV EXPORT  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <p [innerHTML]="data.dialogData.message_text"></p>

  <p-footer fxLayout="row">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionExport_close()"
      [disabled]="data.dialogData.export_in_progress"
      label="Close"
    ></button>
    <span
      fxFlex
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="4px"
      *ngIf="!data.dialogData.show_mode_exported"
    >
      <p-checkbox
        *ngIf="data.payload.exportForImport"
        class="bfx-checkbox dialog-right"
        binary="true"
        label="Export Markup"
        [(ngModel)]="data.dialogData.exportMarkup"
      ></p-checkbox>
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="actionExport_forClipboard()"
        [disabled]="!data.dialogData.clipboard_is_supported"
        title="{{data.dialogData.button_title_text}}"
        label="Copy to Clipboard"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-positive"
        (click)="actionExport_csv()"
        label="Save as CSV"
      ></button>
    </span>
    <span
      fxFlex
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="4px"
      *ngIf="data.dialogData.show_mode_exported && data.dialogData.show_mode_clipboard"
    >
      <button
        pButton
        type="button"
        fxFlex="125px"
        class="bfx-button-positive"
        (click)="actionExport_copyToClipboard()"
        [disabled]="data.dialogData.export_in_progress"
        label="Copy to Clipboard"
      ></button>
    </span>
  </p-footer>
</p-dialog>
